export default "__VITE_ASSET__BRXQwRh$__"